import { Box, Modal, keyframes } from '@mui/material';
import * as React from 'react';
import Iconify from '../iconify';
import useMainStore from '../../store/store';

const slideUpEnter = keyframes`
  0% {
    transform: translateY(150%);
  }
  100% {
    transform: translateY(0);
  }
`;

function IosPWAGuide() {
  const setShowAppModal = useMainStore((s) => s.setShowAppModal);

  return (
    <Modal
      open
      onClose={() => {
        setShowAppModal(false);
      }}
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        p: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          position: 'relative',
          animation: `${slideUpEnter} 0.4s ease-out forwards`,
          background: 'rgba(255,255,255,0.87)',
          borderRadius: '6px',
          padding: '24px 40px 24px 24px',
          backdropFilter: 'blur(5px)',
          fontSize: '14px',
          width: 'calc(100% - 16px)',
          maxWidth: '500px',
          mb: 1,
          outline: 'none',
          '@media (max-width: 600px)': {
            padding: '18px 30px 18px 18px',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          1. Click on the Icon
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => (theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'),
              padding: '8px',
              whiteSpace: 'nowrap',
              borderRadius: '6px',
              marginLeft: '16px',
              color: (theme) => theme.palette.text.primary,
              width: '46px',
            }}
          >
            <Iconify icon="eva:more-horizontal-fill" width={16} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          2. Open the Share menu
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => (theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'),
              padding: '8px',
              whiteSpace: 'nowrap',
              borderRadius: '6px',
              marginLeft: '16px',
              color: (theme) => theme.palette.text.primary,
              width: '46px',
            }}
          >
            <Iconify icon="ion:share-outline" width={16} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          3. Select &quot;More&quot;
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => (theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'),
              padding: '8px',
              whiteSpace: 'nowrap',
              borderRadius: '6px',
              marginLeft: '16px',
              color: (theme) => theme.palette.text.primary,
              width: '46px',
            }}
          >
            <Iconify icon="eva:more-horizontal-fill" width={16} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            '@media (max-width: 600px)': {
              flexDirection: 'column',
              alignItems: 'flex-start',
              '& > div': {
                marginLeft: '0 !important',
                marginTop: '10px',
              },
            },
          }}
        >
          4. Click
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => (theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'),
              padding: '8px',
              whiteSpace: 'nowrap',
              borderRadius: '6px',
              marginLeft: '16px',
              color: (theme) => theme.palette.text.primary,
            }}
          >
            Add to Home Screen
            <Iconify icon="eva:plus-circle-outline" width={16} sx={{ marginLeft: '6px' }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          5. Click
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: (theme) => (theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'),
              padding: '8px',
              whiteSpace: 'nowrap',
              borderRadius: '6px',
              marginLeft: '16px',
              color: '#0079FF',
            }}
          >
            Add
          </Box>
        </Box>

        <Iconify
          icon="eva:close-fill"
          width={16}
          onClick={() => {
            setShowAppModal(false);
          }}
          sx={{
            position: 'absolute',
            minWidth: '25px',
            bottom: '8px',
            right: '8px',
            cursor: 'pointer',
          }}
        />
      </Box>
    </Modal>
  );
}

export default IosPWAGuide;
